import dayjs from 'dayjs';
import type { SalesPortalCheckoutProgressWrite } from 'types';

import type { CheckoutFormValues } from './CheckoutContext';
import type { CheckoutStep } from './checkoutFlowStates';

// Builds the server-side progress save (spec Item 11) from the checkout form. The
// progress row has one column per buyer-typed field and nothing else — payment
// fields, the agreement attestations, the honeypot and medical notes never leave the
// browser. The server rejects any key it has no column for, so adding a field here
// means adding the column there too.
export function buildCheckoutProgressPayload(
  values: CheckoutFormValues,
  currentStep: CheckoutStep,
): SalesPortalCheckoutProgressWrite {
  const info = values.athleteInformation;
  return {
    currentStep,
    whoIsThisFor: values.whoIsThisFor,
    targetProfileId: values.profileId ?? null,
    firstName: info.firstName || null,
    lastName: info.lastName || null,
    email: info.email || null,
    phone: info.phone || null,
    dob: info.dob ? dayjs(info.dob).format('YYYY-MM-DD') : null,
    gender: info.gender || null,
    addressLines: info.address?.addressLines || null,
    addressLocality: info.address?.locality || null,
    addressRegion: info.address?.region || null,
    addressZipCode: info.address?.zipCode || null,
    addressCountry: info.address?.country || null,
    emergencyName: info.emergencyName || null,
    emergencyPhone: info.emergencyPhone || null,
  };
}
